import { FC } from 'react';
import { FormattedRelativeTime } from 'react-intl';

const ONE_SECOND_MILLISECONDS = 1000;

const getTimeOffset = (timestamp: number): number => {
	return Math.round((timestamp - new Date().getTime()) / ONE_SECOND_MILLISECONDS);
};

export const RelativeTime: FC<{ readonly date: Date | string }> = ({ date }) => (
	<FormattedRelativeTime numeric={'auto'} value={getTimeOffset(new Date(date).getTime())} updateIntervalInSeconds={60} />
);
